import { render, staticRenderFns } from "./TeacherStaff.vue?vue&type=template&id=f69b33be"
import script from "./TeacherStaff.vue?vue&type=script&lang=js"
export * from "./TeacherStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports